export const CONTEXT_MENU_OPEN_DEFER_MS = 75;

export const CONTEXT_MENU_OUTSIDE_SUBSCRIBE_DEFER_MS = 400;
